import { keyframes, styled } from "goober";
import type { ReactNode } from "react";
import { zIndexes } from "../../lib/zIndexes";
import { AnchoredPopover } from "../AnchoredPopover";

const popIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  60% {
    opacity: 1;
    transform: scale(1.04);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Bubble = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: var(--tooltip-bg);
  color: var(--tooltip-fg);
  border-radius: 12px;
  box-shadow: var(--elevation-low);
  font-size: 10px;
  pointer-events: none;
  position: relative;
  white-space: nowrap;
  transform-origin: 14px bottom;
  animation: ${popIn} 240ms var(--ease-spring) both;

  &::before {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 10px;
    width: 8px;
    height: 8px;
    background: var(--tooltip-bg);
    transform: rotate(45deg);
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
  }
`;

type Props = {
  show: boolean;
  trigger: (props: { style: React.CSSProperties }) => ReactNode;
};

export function FollowNudge({ show, trigger }: Props) {
  const popoverStyle: React.CSSProperties = {
    bottom: "anchor(top)",
    left: "anchor(center)",
    translate: "-14px 0",
    marginBottom: "10px",
    background: "transparent",
    boxShadow: "none",
    zIndex: zIndexes.tooltip,
  };

  return (
    <AnchoredPopover isOpen={show} trigger={trigger} style={popoverStyle}>
      <Bubble>
        Follow 3B <span style={{ color: "var(--text-secondary)" }}>⌥F</span>
      </Bubble>
    </AnchoredPopover>
  );
}
